import { snakeCase } from 'lodash';
import { COLOR_THEME, STATIC_STORAGE_URL } from '@nexxt/common/constants';
import {
    getTranslation,
    uppercaseFirstLetter
} from '@nexxt/common/services/TextService';
import { ACTION_TYPES, MULTIMEDIA_TYPES, QTYPES } from '@nexxt/common/types';

export const DEFAULT_OPTION = {
    OPTIONS: {
        TRADE_OFF: {},
        VIDEO_ANNOTATION: {},
        NPS: {},
        TREEMAN: [
            {
                id: null,
                label: 'crisis',
                value: '1',
                coordinates: {
                    x: 97.8263315347154,
                    y: 495.4553220035634,
                    width: 285.4010975178948,
                    height: 309.34306658020085
                }
            },
            {
                id: null,
                label: 'well adapted',
                value: '2',
                coordinates: {
                    x: 462.392613131317,
                    y: 210.2071099626157,
                    width: 216.80383143873914,
                    height: 381.2068585261392
                }
            },
            {
                id: null,
                label: 'leader',
                value: '3',
                coordinates: {
                    x: 981.2846286576275,
                    y: 87.68843419322742,
                    width: 231.4786331847523,
                    height: 384.36712186354544
                }
            },
            {
                id: null,
                label: 'optimistic',
                value: '4',
                coordinates: {
                    x: 659.5799819127994,
                    y: 649.2391878949428,
                    width: 237.29622248334135,
                    height: 405.4338015190543
                }
            },
            {
                id: null,
                label: 'follower',
                value: '5',
                coordinates: {
                    x: 939.277022245238,
                    y: 507.76036367668473,
                    width: 180.32585425952902,
                    height: 310.1752161466341
                }
            },
            {
                id: null,
                label: 'refused',
                value: '6',
                coordinates: {
                    x: 1238.6879305000045,
                    y: 120.47999875000009,
                    width: 200,
                    height: 200
                }
            },
            {
                id: null,
                label: 'enlightened',
                value: '7',
                coordinates: {
                    x: 1645.561855866206,
                    y: 67.76675223469441,
                    width: 266.8920955175988,
                    height: 223.50649803061097
                }
            },
            {
                id: null,
                label: 'disgusted',
                value: '8',
                coordinates: {
                    x: 1500.8319145000025,
                    y: 324.766777192208,
                    width: 199.9999999999996,
                    height: 373.0584076155863
                }
            },
            {
                id: null,
                label: 'adopted',
                value: '9',
                coordinates: {
                    x: 1133.561887116202,
                    y: 627.8337212419319,
                    width: 266.8920955175997,
                    height: 373.1324825161392
                }
            },
            {
                id: null,
                label: 'refreshed',
                value: '10',
                coordinates: {
                    x: 326.1682035000126,
                    y: 833.730756295552,
                    width: 235.0875632499756,
                    height: 227.57839615889972
                }
            },
            {
                id: null,
                label: 'sociable',
                value: '11',
                coordinates: {
                    x: 1407.752114463343,
                    y: 823.9581974362158,
                    width: 255.0876080733171,
                    height: 349.5235076275746
                }
            },
            {
                id: null,
                label: 'happy',
                value: '12',
                coordinates: {
                    x: 1441.9016669220632,
                    y: 1230.1068550938385,
                    width: 326.0524946558855,
                    height: 381.00214081232883
                }
            },
            {
                id: null,
                label: 'scared',
                value: '13',
                coordinates: {
                    x: 263.4032939568204,
                    y: 1524.132398783359,
                    width: 172.20139383635996,
                    height: 337.71902018329257
                }
            },
            {
                id: null,
                label: 'struggled',
                value: '14',
                coordinates: {
                    x: 456.0296370461893,
                    y: 1157.5876391081342,
                    width: 184.2606834076237,
                    height: 440.0245780337398
                }
            },
            {
                id: null,
                label: 'motivated',
                value: '15',
                coordinates: {
                    x: 1004.8130182452394,
                    y: 1384.955494111466,
                    width: 180.3258542595296,
                    height: 330.2630969715223
                }
            },
            {
                id: null,
                label: 'desperate',
                value: '16',
                coordinates: {
                    x: 583.3279705000018,
                    y: 1779.3598975000064,
                    width: 200,
                    height: 200
                }
            },
            {
                id: null,
                label: 'contented',
                value: '17',
                coordinates: {
                    x: 1234.1084189442856,
                    y: 1552.9875661147923,
                    width: 176.39102511143517,
                    height: 341.44868177042645
                }
            },
            {
                id: null,
                label: 'exhausted',
                value: '18',
                coordinates: {
                    x: 1440.614548362899,
                    y: 1812.0504759906262,
                    width: 459.6987237742111,
                    height: 196.0588392687511
                }
            },
            {
                id: null,
                label: 'closed',
                value: '19',
                coordinates: {
                    x: 1775.2638977500044,
                    y: 778.4186883804974,
                    width: 199.9999999999997,
                    height: 325.9145327390107
                }
            },
            {
                id: null,
                label: 'supportive',
                value: '20',
                coordinates: {
                    x: 869.2890565493436,
                    y: 1593.8449798343117,
                    width: 156.461795651318,
                    height: 341.65384933138535
                }
            }
        ]
    },
    BUTTONS: {
        HOTSPOT: [
            {
                label: 'Like',
                value: '1',
                texts: [
                    {
                        language: 'en',
                        contents: [
                            { type: MULTIMEDIA_TYPES.TEXT, text: 'Like' }
                        ]
                    }
                ]
            },
            {
                label: 'Confused',
                value: '2',
                texts: [
                    {
                        language: 'en',
                        contents: [
                            { type: MULTIMEDIA_TYPES.TEXT, text: 'Confused' }
                        ]
                    }
                ]
            },
            {
                label: 'Dislike',
                value: '3',
                texts: [
                    {
                        language: 'en',
                        contents: [
                            { type: MULTIMEDIA_TYPES.TEXT, text: 'Dislike' }
                        ]
                    }
                ]
            }
        ],
        TEXT_HIGHLIGHTER: [
            {
                label: 'Like',
                value: '1',
                texts: [
                    {
                        language: 'en',
                        contents: [
                            { type: MULTIMEDIA_TYPES.TEXT, text: 'Like' }
                        ]
                    }
                ]
            },
            {
                label: 'Confused',
                value: '2',
                texts: [
                    {
                        language: 'en',
                        contents: [
                            { type: MULTIMEDIA_TYPES.TEXT, text: 'Confused' }
                        ]
                    }
                ]
            },
            {
                label: 'Dislike',
                value: '3',
                texts: [
                    {
                        language: 'en',
                        contents: [
                            { type: MULTIMEDIA_TYPES.TEXT, text: 'Dislike' }
                        ]
                    }
                ]
            }
        ]
    }
};

export const DEFAULT_BUTTON = {
    LIKE: {
        label: 'Like',
        value: '1',
        color: COLOR_THEME.blue
    },
    CONFUSED: {
        label: 'Confused',
        value: '2',
        color: COLOR_THEME.yellow
    },
    NOT_SURE: {
        label: 'Not sure',
        value: '2',
        color: COLOR_THEME.yellow
    },
    DISLIKE: {
        label: 'Dislike',
        value: '3',
        color: COLOR_THEME.pink
    }
};

const BUTTON_WITH_IMAGE = (
    DEFAULT_BUTTON,
    type = 'like' || 'confused' || 'dislike'
) => ({
    ...DEFAULT_BUTTON,
    mediaURL: `${STATIC_STORAGE_URL}/img/emojis/simple/${type}.png`
});

export const BUTTON_WITH_TRANSLATION = (
    DEFAULT_BUTTON,
    t,
    languageCodes,
    type = 'like' ||
        'confused' ||
        'dislike' ||
        'not sure' ||
        'like much' ||
        'dislike much'
) => ({
    ...DEFAULT_BUTTON,
    texts: languageCodes.map((language) => ({
        language,
        contents: [
            {
                type: MULTIMEDIA_TYPES.TEXT,
                text: getTranslation(
                    t,
                    `BUTTON.${snakeCase(type).toUpperCase()}`,
                    { lng: language },
                    uppercaseFirstLetter(type)
                )
            }
        ]
    }))
});

export const DEFAULT_TRANSLATION_BUTTONS = (type: QTYPES, t, languageCodes) => {
    switch (type) {
        case QTYPES.HOTSPOT:
            return [
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.LIKE, 'like'),
                        t,
                        languageCodes,
                        'like'
                    ),
                    color: COLOR_THEME.green
                },
                BUTTON_WITH_TRANSLATION(
                    BUTTON_WITH_IMAGE(DEFAULT_BUTTON.CONFUSED, 'confused'),
                    t,
                    languageCodes,
                    'confused'
                ),
                BUTTON_WITH_TRANSLATION(
                    BUTTON_WITH_IMAGE(DEFAULT_BUTTON.DISLIKE, 'dislike'),
                    t,
                    languageCodes,
                    'dislike'
                )
            ];
        case QTYPES.TREEMAN:
            return [
                {
                    ...BUTTON_WITH_TRANSLATION(
                        DEFAULT_BUTTON.LIKE,
                        t,
                        languageCodes,
                        'like'
                    ),
                    color: COLOR_THEME.green
                }
            ];
        case QTYPES.VIDEO_ANNOTATION:
            return [
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.LIKE, 'like'),
                        t,
                        languageCodes,
                        'like'
                    ),
                    color: COLOR_THEME.green
                },
                BUTTON_WITH_TRANSLATION(
                    BUTTON_WITH_IMAGE(DEFAULT_BUTTON.CONFUSED, 'confused'),
                    t,
                    languageCodes,
                    'confused'
                ),
                BUTTON_WITH_TRANSLATION(
                    BUTTON_WITH_IMAGE(DEFAULT_BUTTON.DISLIKE, 'dislike'),
                    t,
                    languageCodes,
                    'dislike'
                )
            ];
        case QTYPES.TEXT_HIGHLIGHTER:
            return [
                BUTTON_WITH_TRANSLATION(
                    DEFAULT_BUTTON.LIKE,
                    t,
                    languageCodes,
                    'like'
                ),
                BUTTON_WITH_TRANSLATION(
                    DEFAULT_BUTTON.CONFUSED,
                    t,
                    languageCodes,
                    'confused'
                ),
                BUTTON_WITH_TRANSLATION(
                    DEFAULT_BUTTON.DISLIKE,
                    t,
                    languageCodes,
                    'dislike'
                )
            ];
        case QTYPES.TRADE_OFF:
            return [
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.DISLIKE, 'dislike'),
                        t,
                        languageCodes,
                        'dislike much'
                    ),
                    label: 'Dislike very much',
                    type: ACTION_TYPES.DISLIKE
                },
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.DISLIKE, 'dislike'),
                        t,
                        languageCodes,
                        'dislike'
                    ),
                    type: ACTION_TYPES.DISLIKE
                },
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.NOT_SURE, 'confused'),
                        t,
                        languageCodes,
                        'not sure'
                    ),
                    type: ACTION_TYPES.NOT_SURE
                },
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.LIKE, 'like'),
                        t,
                        languageCodes,
                        'like'
                    ),
                    type: ACTION_TYPES.LIKE
                },
                {
                    ...BUTTON_WITH_TRANSLATION(
                        BUTTON_WITH_IMAGE(DEFAULT_BUTTON.LIKE, 'like'),
                        t,
                        languageCodes,
                        'like much'
                    ),
                    label: 'Like very much',
                    type: ACTION_TYPES.LIKE
                }
            ];
        default:
            return [];
    }
};
